import React from 'react'
import OrderNavBar from 'ui/order/OrderNavBar'

function CartSkeleton() {
	return (
		<div className="container flex flex-col md:flex-row md:justify-center animate min-h-screen animate-pulse !max-w-[--account-max-w]">
			<div className="md:flex-grow">
				<OrderNavBar />
				<div className="pt-6">
					<CartHeaderSkeleton />
					<CartItemSkeleton />
				</div>
			</div>
			<CartSummarySkeleton />
		</div>
	)
}

function CartHeaderSkeleton() {
	return (
		<div className="mb-6">
			{/* Breadcrumbs */}
			<div className="h-4 bg-skeleton-gray rounded w-1/4 mb-4"></div>
			{/* Order Name */}
			<div className="h-4 bg-skeleton-gray rounded w-20 mt-14"></div>
			<div className="h-8 bg-skeleton-gray rounded w-1/2 mt-2"></div>
		</div>
	)
}

function CartItemSkeleton() {
	return <div className="pb-20 pt-12 first:pt-4 rounded-lg bg-skeleton-gray h-[593px]" />
}

function CartSummarySkeleton() {
	return (
		<div
			className="order-summary @container 
								relative md:sticky md:top-6 md:bottom-6 md:right-6 xl:right-10 
								md:w-[350px] xl:w-[432px] md:ml-6 lg:ml-10
								md:h-[845px] md:max-h-[calc(100vh_-_50px)] md:overflow-y-auto
								max-md:h-max
								flex flex-col justify-between 
								bg-skeleton-gray rounded-lg p-6 z-10"
		>
			<div>
				<div className="h-8 bg-skeleton-gray rounded w-1/2 mb-4"></div>
				<div className="h-4 bg-skeleton-gray rounded w-3/4 mb-2"></div>
				<div className="h-4 bg-skeleton-gray rounded w-1/2 mb-4"></div>
				<div className="h-12 bg-skeleton-gray rounded mb-4"></div>
				<div className="h-4 bg-skeleton-gray rounded w-full mb-2"></div>
				<div className="h-4 bg-skeleton-gray rounded w-3/4"></div>
			</div>
			<div className="mt-6">
				<div className="h-12 bg-skeleton-gray rounded mb-4"></div>
				<div className="h-4 bg-skeleton-gray rounded w-full"></div>
			</div>
		</div>
	)
}

export default CartSkeleton
